import React from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { useGqlDutyListQuery } from 'generated/graphql'
import Pagination from '@app.components/Pagination/Pagination'
import {
  CustomScrollBarCss,
  NoDragTextSelectionCss,
} from '@app.feature/coverletter/coverletter.write/styles'
import BounceLoading from 'components/BounceLoading'
import { useDutyModalStore } from '../../store/dutyModal'
import DutyItem from './DutyItem'
import DutyListHeader from './DutyListHeader/DutyListHeader'
import SearchResultNotFound from './SearchResultNotFound'

gql`
  query gqlDutyList(
    $orderBy: DutyOrder
    $filterBy: DutyFilters
    $pagination: Pagination
  ) {
    duties(orderBy: $orderBy, filterBy: $filterBy, pagination: $pagination) {
      nodes {
        ...DutyItem_Duty
      }
      totalCount
    }
  }
`

const DutyList: React.FC = () => {
  const variables = useDutyModalStore((store) => store.variables)
  const setVariables = useDutyModalStore((store) => store.setVariables)

  const { data, loading, error } = useGqlDutyListQuery({
    variables,
    fetchPolicy: 'cache-and-network',
  })

  const handleChange = (page: number) => {
    if (!variables || !variables.pagination) return

    setVariables({
      ...variables,
      pagination: {
        ...variables.pagination,
        page,
      },
    })
  }

  return (
    <StyledWrapper>
      <DutyListHeader />
      <div className="list-wrapper">
        {(() => {
          // * Loading
          if (loading || error || !data?.duties.nodes)
            return (
              <div className="root-loading-wrapper">
                <BounceLoading className="loading" />
                <div className="loading-text">공고를 불러오고 있습니다.</div>
              </div>
            )
          // * Empty
          if (data.duties.nodes.length === 0) return <SearchResultNotFound />
          return data.duties.nodes
            .filter((node) => node !== null)
            .map((node) => (
              <DutyItem
                key={`RecruitList-${node!.id}`}
                data={node!}
                length={data.duties.nodes.length}
              />
            ))
        })()}
      </div>
      <div className="pagination-wrapper">
        <Pagination
          type="value"
          stepSize={10}
          totalCount={data?.duties.totalCount}
          pageSize={variables?.pagination?.pageSize}
          value={loading ? 1 : variables?.pagination?.page}
          onChange={handleChange}
          isDisabled={loading}
        />
      </div>
    </StyledWrapper>
  )
}

export default DutyList

const StyledWrapper = styled.div`
  ${NoDragTextSelectionCss}
  >.list-wrapper {
    position: relative;
    overflow: auto;

    height: 550px;
    ${CustomScrollBarCss}
  }
  .root-loading-wrapper {
    height: 550px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .loading {
      margin-bottom: 30px;
    }
    .loading-text {
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      text-align: center;
    }
  }
  .pagination-wrapper {
    padding-top: 20px;
  }
`
